// Moves the Give Feedback form's submission status message (success/failure) to sit right after
// the Submit button, instead of leaving it in Optimizely Forms' default position above all the
// fields. On a long form, a visitor who submitted from further down the page had to scroll all the
// way back up to see whether it succeeded or why it was rejected (e.g. a QIS validation error) —
// the message was rendering correctly, just out of view.
//
// A popup/modal version of this was tried first and explicitly rejected by the client in favour of
// keeping the plain inline message Optimizely Forms renders by default — just moved to where the
// visitor already is. Optimizely's own submit handler (EPiServerForms.js) finds this element by
// class within the form regardless of where it sits in the DOM, so a one-time move at page load is
// enough; no observer or ongoing JS is needed to keep it working after each submission.
document.querySelectorAll<HTMLElement>('.Form__Status').forEach((statusContainer) => {
  const form = statusContainer.closest('.EPiServerForms');
  // Insert after the whole main-body/steps block (data-f-mainbody), not directly after the Submit
  // button itself: the button lives inside .FormStep, a CSS Grid container, and dropping this
  // element in there makes it a grid item with no grid-column rule of its own, collapsing it to
  // zero height (confirmed live — width/height came back as 404x0). Placing it after .Form__MainBody
  // keeps it in normal block flow, still visually right below Submit since the button is the last
  // thing inside that block.
  const mainBody = form?.querySelector<HTMLElement>('.Form__MainBody, [data-f-mainbody]');

  if (mainBody) {
    mainBody.insertAdjacentElement('afterend', statusContainer);
  }
});

// VoiceOver fix — YOURTOWN ONLY.

const isYourtown = (): boolean => {
  const app = document.documentElement.getAttribute('data-app');
  return app?.trim().toLowerCase() === 'yourtown';
};

if (isYourtown()) { 
  const ERROR_SELECTOR = [
    '.Form__Element.ValidationFail .field-validation-error',
    '.Form__Element.ValidationFail .Form__Element__ValidationError',
    '[data-valmsg-summary="true"] li',
  ].join(', ');
 
  const announceTopMostError = (form: HTMLElement) => {
    const topError = form.querySelector<HTMLElement>(ERROR_SELECTOR);
    if (!topError) {
      return;
    }

    const field = topError
      .closest<HTMLElement>('.Form__Element')
      ?.querySelector<HTMLElement>(
        'input:not([type="hidden"]), select, textarea, [role="combobox"]'
      );

    if (field) {      
      if (!field.hasAttribute('aria-describedby')) {
        if (!topError.id) {
          topError.id = `form-err-${Math.random().toString(36).slice(2, 9)}`;
        }
        field.setAttribute('aria-describedby', topError.id);
      }
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    } else {      
      topError.setAttribute('tabindex', '-1');
      topError.setAttribute('role', 'alert');
      topError.setAttribute('aria-live', 'assertive');
      topError.focus();
    }
  };
  
  const pending = new WeakMap<HTMLElement, number>();
  const schedule = (form: HTMLElement) => {
    const existing = pending.get(form);
    if (existing) {
      window.clearTimeout(existing);
    }
    pending.set(
      form,
      window.setTimeout(() => {
        pending.delete(form);
        announceTopMostError(form);
      }, 50)
    );
  };
  
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      const target = m.target as HTMLElement;
      if (
        m.attributeName === 'class' &&
        target.classList.contains('ValidationFail') &&
        !(m.oldValue ?? '').split(/\s+/).includes('ValidationFail')
      ) {
        const form = target.closest<HTMLElement>('.EPiServerForms');
        if (form) {
          schedule(form);
        }
      }
    }
  }).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true,
  });
}
